import styled from 'styled-components';
import { media } from '@payright/web-components';

const SCStep3 = styled.div`
  hr {
    border-style: solid;
    border-bottom: none;
    border-color: ${(props) => props.theme.colours.grey.altlight};
    margin: 2.23em 0 3em;
  }

  .card-details {
    & > div {
      margin-top: 1.6em;
    }
  }

  .header {
    margin: 0em 0;
    &__title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      h4 {
        color: ${(props) => props.theme.colours.blue.base};
      }
      button {
        font-size: 0.86em;
        svg {
          width: 11px;
          height: 11px;
        }
      }
    }
  }

  .payment-details,
  .payment-start-date {
    margin-bottom: 3em;

    ${media.min.medium} {
      margin-bottom: 5.5em;
    }
  }

  .save-payment-details {
    margin-bottom: 1.5em;

    ${media.min.medium} {
      margin-bottom: 1em;
      float: right;
    }
  }

  .expiry-cvc {
    display: flex;

    .card-expiry {
      flex: 0.6;
      margin-right: 1em;
    }
    .card-cvc {
      flex: 0.4;
      margin-left: 1em;
    }
    ${media.max.medium} {
      flex-direction: column;
      .card-expiry {
        margin-right: 0;
        margin-bottom: 1.6em;
      }
      .card-cvc {
        margin-left: 0;
      }
    }
  }

  .back-to-step-1 {
    margin: 3em 0;
    text-align: center;
  }
`;


export const SCCustomerDetails = styled.div`
  background: ${(props) => props.theme.colours.white};
  hr {
    border-style: solid;
    border-bottom: none;
    border-color: ${(props) => props.theme.colours.grey.altlight};
    margin: 3rem 0;
  }

  .customerdetails-body {
    max-width: 1200px;
    width: 100%;
    margin: 4rem auto 3rem;

    ${media.max.medium} {
      margin: 1.6rem auto 0;
    }
    ${media.max.ewide} {
      padding: 0 1.6rem;
    }

    h4 {
      color: ${(props) => props.theme.colours.blue.base};
    }
  }

  .button-actiongroup-wrapper {
    padding: 30px 0px 30px 0px;
    display: flex;
    justify-content: space-between;
    .save-for-later {
      margin-right: 0.5rem;
    }
    ${media.min.medium} {
      .save-for-later {
        margin-right: 1rem;
        margin-left: 1.5rem;
        width: 250px;
      }
    }
    ${media.min.large} {
      .save-for-later {
        margin-right: 1rem;
        margin-left: 0rem;
        width: 400px;
      }
    }
  }

  .alert-container {
    margin-bottom: 3rem;
  }
`;


export default SCStep3;
